var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 4V19M6 19H5.5C5.22386 19 5 19.2239 5 19.5V19.5C5 19.7761 5.22386 20 5.5 20H6.5C6.77614 20 7 19.7761 7 19.5V19.5C7 19.2239 6.77614 19 6.5 19H6Z",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 4V19",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 19H18H18.5C18.7761 19 19 19.2239 19 19.5C19 19.7761 18.7761 20 18.5 20H17.5C17.2239 20 17 19.7761 17 19.5C17 19.2239 17.2239 19 17.5 19Z",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 14.5H1.5M23 14.5H22.5M23 12C22.2258 12 21.5639 11.8002 21 11.4586M12 12V14.5M12 12C12.6556 12 13.526 11.8281 14.4 11.3716M12 12C11.2481 12 10.5845 11.8691 10 11.6381M1 12C1.15379 12 1.32176 11.9864 1.5 11.9566M1.5 11.9566V14.5M1.5 11.9566C1.95492 11.8807 2.47669 11.6996 3 11.3716M1.5 14.5H3M3 11.3716V14.5M3 11.3716C3.49802 11.0595 3.99743 10.6143 4.44195 10M3 14.5H4.44195M4.44195 10C5.33069 8.77186 6 6.86783 6 4C6 5.61434 6.43978 8.20597 7.8518 10M4.44195 10V14.5M4.44195 14.5H7.8518M7.8518 10V14.5M7.8518 10C8.40686 10.7052 9.11214 11.2872 10 11.6381M7.8518 14.5H10M12 14.5H14.4M12 14.5H10M16.5 9.53093V14.5M16.5 14.5H14.4M16.5 14.5H19.5M14.4 11.3716C16.1925 10.4354 18 8.30222 18 4C18 5.61434 18.3665 8.20597 19.5432 10M14.4 11.3716V14.5M10 11.6381V14.5M19.5432 10L19.5 14.5M19.5432 10C19.934 10.5959 20.4142 11.1037 21 11.4586M19.5 14.5H21M22.5 12V14.5M22.5 14.5H21M21 11.4586V14.5",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.9eebb8748b142a39e2e83970d2d96e09.svg";
export { ForwardRef as ReactComponent };